import * as React from "react";
import Svg, { Path } from "react-native-svg";

const MapLocationFilledIcon = (props) => {
  return (
    <Svg
      width={25}
      height={24}
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <Path
        d="M10.083 9a2.25 2.25 0 114.5 0 2.25 2.25 0 01-4.5 0z"
        fill="#001533"
      />
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.171 2.5A6.153 6.153 0 006.04 8.148 6.645 6.645 0 007.517 12.9l3.595 4.396a1.578 1.578 0 002.443 0l3.594-4.396a6.645 6.645 0 001.479-4.752A6.153 6.153 0 0012.495 2.5h-.324zm.162 2.75a3.75 3.75 0 100 7.5 3.75 3.75 0 000-7.5z"
        fill="#001533"
      />
      <Path
        d="M7.669 15.33a.75.75 0 01.335 1.005L6.547 19.25H18.12l-1.458-2.915a.75.75 0 011.342-.67l2 4a.75.75 0 01-.67 1.085h-14a.75.75 0 01-.672-1.085l2-4a.75.75 0 011.007-.336z"
        fill="#001533"
      />
    </Svg>
  );
};

export default MapLocationFilledIcon;
